import React from 'react'
import { ConsentPage } from './ConsentPage'

export const EskatConsent = () => (
  <ConsentPage serviceName="Eskat" servicePath="eskat_integration_mock" />
)
